export const da = {
  nav: {
    start: "Start",
    losningar: "Løsninger",
    produkter: "Tjenester",
    kundcase: "Kundecases",
    kunskap: "Viden",
    information: "Information",
    nyheter: "Nyheder",
    villkor: "Vilkår",
    developer: "Developer",
    omGeposit: "Om Geposit",
    kontakt: "Kontakt",
    bokademo: "Book demo",
    loggain: "Log ind",
    bestall: "Bestil",
  },
  hero: {
    title: "Geografisk kontrol over din virksomhed",
    subtitle:
      "Validér adresser, håndtér geografiske områder og kvalitetssikr jeres adresseregistre i Sverige, Norge, Danmark og Finland – alt i én platform. For smartere beslutninger og færre fejl i hvert led.",
    cta: "Book demo",
    ctaSecondary: "Se vores løsninger",
  },
  segments: {
    title: "Hvem vi hjælper",
    subtitle:
      "Geposit understøtter virksomheder i Sverige, Norge, Danmark og Finland med at effektivisere geografisk planlægning og leveringslogistik.",
    transport: {
      title: "Transport & Logistik",
      description:
        "Definér leveringsområder med postnummerpræcision, sikr korrekte adressedata og reducér returneringer. Fuld kontrol over jeres transportgeografi.",
    },
    service: {
      title: "Service & Installation",
      description:
        "Planlæg serviceområder, fordel ressourcer geografisk og giv jeres kunder præcise besøgstider. Undgå overlappende zoner.",
    },
    ecommerce: {
      title: "E-handel & Omni",
      description:
        "Definér leveringszoner, validér kundeadresser i realtid og optimér jeres sidste-mil-logistik. Færre fejl, tilfredse kunder.",
    },
  },
  problems: {
    title: "Genkender du dette?",
    subtitle: "Mange virksomheder kæmper med de samme geografiske udfordringer hver dag.",
    items: {
      areas: {
        title: "Utydelige områder",
        description:
          "Geografiske ansvarsområder baseres på mavefornemmelse i stedet for data. Ingen ved egentlig, hvor grænserne går.",
      },
      addresses: {
        title: "Forkerte adressedata",
        description:
          "Pakker kommer retur, serviceteknikere finder ikke frem, og kunderne bliver frustrerede over forsinkelser.",
      },
      manual: {
        title: "Manuel planlægning",
        description:
          "Excel-ark, kort på væggen og timer med manuelt arbejde for at fordele og opdatere geografiske områder.",
      },
      overview: {
        title: "Manglende overblik",
        description:
          "Ingen ved egentlig, hvordan de geografiske områder ser ud, eller om de er optimalt fordelt og dækker alle behov.",
      },
    },
  },
  solutions: {
    title: "Sådan løser Geposit det",
    subtitle:
      "Tre søjler, der giver dig fuld kontrol over din geografi og adressekvalitet i hele Norden.",
    pillars: {
      areas: {
        title: "Egne områder med postnummerpræcision",
        description:
          "Opret, visualisér og håndtér jeres unikke geografiske områder med postnummerflader som byggesten. Opdatér i realtid, når behovene ændrer sig.",
      },
      data: {
        title: "Korrekte adresse- og postnummerdata",
        description:
          "Altid opdaterede, validerede data, der sikrer, at hver adresse er korrekt. Reducér returneringer og fejlomkostninger drastisk.",
      },
      control: {
        title: "Visuelt overblik & kontrol",
        description:
          "Se hele jeres geografi på kortet. Analysér, optimér og tag beslutninger baseret på data – ikke mavefornemmelse.",
      },
    },
  },
  products: {
    title: "Vores tjenester",
    subtitle:
      "Tre kraftfulde værktøjer, der giver dig kontrol over geografi og adressedata – med fuld dækning i hele Norden.",
    atlas: {
      title: "Atlas",
      description:
        "Opret og håndtér egne geografiske områder for Sverige, Norge, Danmark og Finland. Visualisér, analysér og optimér jeres geografiske strukturer på et interaktivt kort.",
      cta: "Læs mere om Atlas",
    },
    valid: {
      title: "Valid",
      description:
        "Validér og berig adresser i realtid for alle nordiske lande. Sikr, at hver adresse er korrekt, inden den når jeres system – via API eller søgetjeneste i webgrænsefladen.",
      cta: "Læs mere om Valid",
    },
    adresstwatt: {
      title: "Adressevask",
      description:
        "Vask og kvalitetssikr jeres eksisterende adresseregistre i hele Norden. Find og korriger fejl i bulk for at forbedre datakvaliteten.",
      cta: "Læs mere om Adressevask",
    },
  },
  productPages: {
    backToProducts: "Alle tjenester",
    features: "Funktioner",
    benefits: "Fordele",
    howItWorks: "Sådan fungerer det",
    ctaTitle: "Klar til at komme i gang?",
    ctaSubtitle: "Book en demo og se, hvordan det fungerer for netop jeres virksomhed.",
    ctaButton: "Book demo",
    ctaSecondary: "Kontakt os",
    atlas: {
      hero: {
        title: "Atlas",
        tagline: "Geografisk områdehåndtering",
        subtitle:
          "Opret, visualisér og håndtér jeres egne geografiske områder på et interaktivt kort. Definér salgsdistrikter, leveringszoner og serviceområder med postnummerpræcision – i Sverige, Norge, Danmark og Finland.",
      },
      overview:
        "Atlas er Geposits korttjeneste til at oprette og håndtere egne geografiske områder i hele Norden. Byg jeres områder op med postnummerflader som byggesten, tegn frihånd eller importér eksisterende strukturer. Visualisér data som heat maps, mål afstande og del kort med hele organisationen – via iFrame eller API. Atlas understøtter Sverige, Norge, Danmark og Finland.",
      featureGroups: {
        createAndVisualize: "Opret & visualisér med postnumre",
        calculateAndAnalyze: "Mål & analysér",
        integrateAndShare: "Integrér & del",
      },
      features: {
        title: "Alt du behøver til geografisk planlægning",
        subtitle:
          "Atlas giver jer værktøjerne til at tage kontrol over jeres geografiske strukturer – enkelt, visuelt og datadrevet.",
        items: {
          points: {
            title: "Punkter på kort",
            description:
              "Placér punkter med adresse eller koordinat. Visualisér kundedata, lagre eller servicepunkter – enkeltvis eller som heat map.",
          },
          areas: {
            title: "Egne områder med postnumre",
            description:
              "Byg områder op med postnummerflader som byggesten – hvert postnummer klikker på plads som en puslespilsbrik. Tegn frihånd, importér shapefiler eller kombinér metoder for fuld fleksibilitet.",
          },
          heatmaps: {
            title: "Heat maps",
            description:
              "Visualisér datamønstre geografisk med heat maps. Se koncentrationer af kunder, leveringer eller servicebehov direkte på kortet.",
          },
          routes: {
            title: "Afstandsberegning",
            description:
              "Beregn afstande og rejsetid mellem punkter. Vælg køretøjstype for realistiske estimater – en støtte ved planlægning af serviceområder og optagezoner.",
          },
          measure: {
            title: "Måleværktøjer",
            description:
              "Brug rækkevidde-cirkler til at måle afstand fra et punkt. Perfekt til at definere optageområder eller serviceradius.",
          },
          attributes: {
            title: "Attributter & metadata",
            description:
              "Tilknyt egne data til områder og punkter. Tilføj priszoner, ansvarlige sælgere, kapacitet eller andre forretningsregler.",
          },
          iframe: {
            title: "iFrame-deling",
            description:
              "Indlejr jeres kort direkte på en hjemmeside eller i et internt system. Giv kolleger og partnere adgang uden login.",
          },
          api: {
            title: "API-integration",
            description:
              "Hent og send data programmatisk via REST API. Integrér Atlas med jeres CRM, ERP, transportsystem eller BI-platform.",
          },
        },
      },
      useCases: {
        title: "Anvendelsesområder",
        items: {
          salesDistricts: {
            title: "Salgsdistrikter",
            description:
              "Definér og visualisér sælgernes ansvarsområder. Se dækning, identificér huller og balancér arbejdsbelastningen.",
          },
          deliveryZones: {
            title: "Leveringszoner",
            description:
              "Opret tydelige leveringsområder pr. terminal, chauffør eller region. Alle ser det samme billede.",
          },
          priceZones: {
            title: "Priszoner",
            description:
              "Definér geografiske zoner med forskellig prissætning. Tilknyt til forretningssystemet for automatisk prisberegning.",
          },
          biConnection: {
            title: "BI & analyse",
            description:
              "Eksportér geodata til jeres BI-værktøj eller tilknyt direkte via API. Geografisk dimension i jeres rapporter.",
          },
          distanceCalc: {
            title: "Afstandsberegning",
            description:
              "Beregn afstande og rejsetider mellem punkter med forskellige køretøjstyper. En støtte ved planlægning og tidsstyring.",
          },
          crmConnection: {
            title: "CRM-tilknytning",
            description:
              "Synkronisér geografiske områder med jeres CRM-system. Automatisk tildeling af kunder til den rigtige sælger.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Atlas?",
        items: {
          time: {
            title: "Spar tid",
            description:
              "Stop med manuelle Excel-ark og papirkort. Gør på minutter, hvad der tidligere tog timer.",
          },
          decisions: {
            title: "Bedre beslutninger",
            description:
              "Basér jeres geografiske beslutninger på data i stedet for mavefornemmelse. Se mønstre og optimeringsmuligheder direkte.",
          },
          overview: {
            title: "Fuldt overblik",
            description:
              "Alle i organisationen ser det samme billede. Ingen flere uklarheder om, hvor grænserne går.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Importér jeres data",
            description:
              "Upload jeres eksisterende områder, adresser eller koordinater. Atlas understøtter shapefiler, CSV og API-import.",
          },
          second: {
            title: "Opret og tilpas",
            description:
              "Byg områder med postnummerflader som byggesten, tegn frihånd, visualisér med heat maps og mål afstande.",
          },
          third: {
            title: "Del og integrér",
            description:
              "Publicér kort via iFrame, eksportér data eller tilknyt jeres systemer via API.",
          },
        },
      },
      pricing: {
        features: {
          binding12: "12 måneders bindingsperiode",
          adminMapCountry: "1 admin, 1 kort, 1 land",
          importData: "Importér egne data på kort",
          manageAreas: "Opret, vis og håndtér områder",
          apiIntegration: "Integrér med jeres systemer via API",
          export2000: "Eksportér 2.000 postnumre/md.",
          exportUnlimited: "Eksportér ubegrænset antal postnumre",
          routingIncluded: "Routing Small inkluderet",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "1.795 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "2.995 SEK",
          },
          medium3: {
            name: "MEDIUM 3-MD.",
            price: "3.595 SEK",
          },
        },
        addons: {
          extraCountry: { name: "Ekstra land", price: "1.000 SEK/md." },
          extraMap: { name: "Ekstra kort", price: "495 SEK/md." },
          extraAdmin: { name: "Ekstra admin-bruger", price: "295 SEK/md." },
          extraViewer: { name: "Ekstra kig-bruger", price: "95 SEK/md." },
          exportPostal: { name: "Eksport postnumre", small: "0,80 SEK/stk.", mediumPlus: "Inkluderet" },
          exportCoords: { name: "Eksport koordinater", small: "1,00 SEK/stk.", mediumPlus: "0,90 SEK/stk." },
        },
      },
    },
    valid: {
      hero: {
        title: "Valid",
        tagline: "Adressevalidering & berigelse",
        subtitle:
          "Validér, korrigér og berig adresser i realtid for Sverige, Norge, Danmark og Finland. Via API, autocomplete i formularer eller søgetjeneste i webgrænseflade – Valid sikrer korrekte adressedata i hvert trin.",
      },
      overview:
        "Valid er Geposits tjeneste til adressevalidering, autocomplete og berigelse med komplet nordisk dækning. Kontrollér, om en adresse findes i Sverige, Norge, Danmark eller Finland, giv brugeren smarte forslag, mens de skriver, og berig hver adresse med over 10 geografiske attributter. Tilgængelig via REST API eller som søgetjeneste i webgrænsefladen.",
      featureGroups: {
        api: "API-tjenester",
        web: "Webgrænseflade",
      },
      features: {
        title: "Korrekte adressedata – hver gang",
        subtitle:
          "Valid fanger fejl, før de bliver et problem. Integrér i jeres systemer eller brug søgetjenesten direkte i browseren.",
        items: {
          validation: {
            title: "Adressevalidering",
            description:
              "Kontrollér, om en adresse findes og er korrekt. Få øjeblikkelig feedback med statusindikering og forslag til korrektion.",
          },
          autocomplete: {
            title: "Autocomplete",
            description:
              "Giv brugeren smarte adresseforslag i realtid, mens de skriver. Hurtigere udfyldning, færre fejl, bedre brugeroplevelse.",
          },
          enrichment: {
            title: "Berigelse",
            description:
              "Kompletér hver adresse med over 10 attributter: region, kommune, bydel, sogn, koordinater, ejendomsbetegnelse, DeSO/RegSO med mere.",
          },
          search: {
            title: "Søgetjeneste i webgrænseflade",
            description:
              "Søg og verificér adresser direkte i Geposits webgrænseflade – uden at skulle integrere via API. Perfekt til manuel kontrol.",
          },
          coverage: {
            title: "Nordisk dækning",
            description:
              "Komplet adressedatabase for Sverige, Norge, Danmark og Finland. Opdateres hver uge med data fra officielle grundkilder.",
          },
        },
      },
      enrichmentData: {
        title: "Berigelsesattributter",
        subtitle:
          "Hver valideret adresse kan beriges med følgende geografiske og administrative attributter.",
        items: {
          county: {
            name: "Region",
            description: "Administrativ region, som adressen tilhører",
          },
          municipality: {
            name: "Kommune",
            description: "Kommune, som adressen er registreret i",
          },
          district: {
            name: "Bydel",
            description: "Geografisk distrikt inden for kommunen",
          },
          parish: {
            name: "Sogn",
            description: "Kirkesogn for adressen",
          },
          lkfCode: {
            name: "LKF-kode",
            description:
              "Statistisk områdekode (Region, Kommune, Sogn)",
          },
          municipalityCode: {
            name: "Kommunekode",
            description: "Officiel numerisk kommunekode",
          },
          property: {
            name: "Ejendomsbetegnelse",
            description:
              "Officiel ejendomsbetegnelse fra Geodatastyrelsen",
          },
          coordinates: {
            name: "Koordinater",
            description:
              "Breddegrad og længdegrad (WGS84) for adressen",
          },
          deso: {
            name: "DeSO",
            description: "Demografisk statistikområde (SCB)",
          },
          regso: {
            name: "RegSO",
            description: "Regionalt statistikområde (SCB)",
          },
          uuid: {
            name: "UUID",
            description: "Unik identifikator for adressen",
          },
          postalCode: {
            name: "Postnummer",
            description: "Verificeret og aktuelt postnummer",
          },
          city: {
            name: "Postby",
            description:
              "Officiel postby tilknyttet postnummeret",
          },
        },
      },
      useCases: {
        title: "Anvendelsesområder",
        items: {
          checkout: {
            title: "E-handel checkout",
            description:
              "Integrér autocomplete og validering i kassen. Kunden indtaster den rigtige adresse med det samme – færre returneringer, hurtigere levering.",
          },
          booking: {
            title: "Bookingportaler",
            description:
              "Sikr korrekte adresser ved servicebooking. Teknikeren finder frem med det samme uden unødvendige opkald.",
          },
          systemIntegration: {
            title: "Systemintegration",
            description:
              "Validér og berig adresser ved import til CRM, ERP eller marketingsystemer. Sikr datakvalitet fra start.",
          },
          crmQuality: {
            title: "CRM-kvalitet",
            description:
              "Kør jeres kunderegistre gennem Valid for at identificere og korrigere forkerte adresser. Bedre data, bedre beslutninger.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Valid?",
        items: {
          returns: {
            title: "Færre returneringer",
            description:
              "Korrekte adressedata fra start betyder færre breve og pakker, der kommer retur.",
          },
          experience: {
            title: "Bedre kundeoplevelse",
            description:
              "Hurtigere formularer med autocomplete og direkte validering. Jeres kunder sætter pris på det.",
          },
          costs: {
            title: "Lavere omkostninger",
            description:
              "Hver forkert adresse koster jer penge. Valid betaler sig selv gennem reducerede fejlomkostninger.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Integrér eller søg",
            description:
              "Tilknyt Valid til jeres system via REST API, eller brug søgetjenesten direkte i webgrænsefladen.",
          },
          second: {
            title: "Validér og berig",
            description:
              "Adresser valideres i realtid. Forkerte adresser korrigeres og beriges med 10+ attributter automatisk.",
          },
          third: {
            title: "Korrekte data – altid",
            description:
              "Hver adresse i jeres system er verificeret, komplet og forbundet med aktuelle geografiske data.",
          },
        },
      },
      demo: {
        title: "Prøv Valid",
        subtitle: "Prøv tjenesten direkte – vælg land, skriv en adresse og se, hvordan Valid validerer, foreslår og beriger i realtid.",
        countryLabel: "Vælg land:",
        countries: {
          se: "Sverige",
          no: "Norge",
          dk: "Danmark",
          fi: "Finland",
        },
        tabs: {
          autocomplete: "Autocomplete",
          validate: "Validér",
          enrich: "Berig",
        },
        autocomplete: {
          description: "Begynd at skrive en adresse og se forslag i realtid. Vælg et forslag for at udfylde adressen.",
          placeholder: "Begynd at skrive en adresse…",
          selected: "Valgt adresse",
        },
        validate: {
          description: "Indtast en adresse og klik på Validér for at kontrollere, om den findes og er korrekt.",
          streetLabel: "Gadeadresse",
          streetPlaceholder: "f.eks. Strøget 1",
          postcodeLabel: "Postnummer",
          postcodePlaceholder: "f.eks. 1000",
          localityLabel: "By",
          localityPlaceholder: "f.eks. København",
          button: "Validér adresse",
          validMessage: "Adressen er korrekt!",
          invalidMessage: "Adressen kunne ikke valideres",
          suggestions: "Mente du måske:",
        },
        enrich: {
          description: "Indtast en adresse og klik på Berig for at se alle tilhørende geografiske og administrative data.",
          button: "Berig adresse",
          errorMessage: "Adressen kunne ikke beriges. Kontrollér, at den er korrekt.",
        },
      },
      pricing: {
        features: {
          nordicValidation: "Validering af adresser i hele Norden",
          autocomplete: "Autocomplete for gadenavne, postnumre og byer",
          adminControl: "Kontrol af region, kommune, sogn og bydel",
        },
        details: {
          validationsIncluded: "Valideringer/md.",
          autocompleteIncluded: "Autocomplete/md.",
          extraValidation: "Overskydende validering",
          extraAutocomplete: "Overskydende autocomplete",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "695 SEK",
            validations: "1.000",
            autocomplete: "7.500",
            extraValidation: "0,50 SEK",
            extraAutocomplete: "0,07 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "1.795 SEK",
            validations: "6.000",
            autocomplete: "45.000",
            extraValidation: "0,35 SEK",
            extraAutocomplete: "0,05 SEK",
          },
          large: {
            name: "LARGE",
            price: "3.995 SEK",
            validations: "20.000",
            autocomplete: "150.000",
            extraValidation: "0,25 SEK",
            extraAutocomplete: "0,03 SEK",
          },
          xl: {
            name: "XL",
            price: "5.995 SEK",
            validations: "40.000",
            autocomplete: "300.000",
            extraValidation: "0,15 SEK",
            extraAutocomplete: "0,01 SEK",
          },
        },
        addons: {
          geocodePostal: { name: "Geokodning postnummer", small: "1,00 SEK/stk.", medium: "0,90 SEK/stk.", large: "0,80 SEK/stk.", xl: "0,70 SEK/stk." },
          geocodeAddress: { name: "Geokodning adresse", small: "Ifølge tilbud", medium: "Ifølge tilbud", large: "Ifølge tilbud", xl: "Ifølge tilbud" },
          uuid: { name: "UUID", small: "0,10 SEK/stk.", medium: "0,08 SEK/stk.", large: "0,06 SEK/stk.", xl: "0,04 SEK/stk." },
          property: { name: "Ejendomsbetegnelse", small: "0,50 SEK/stk.", medium: "0,40 SEK/stk.", large: "0,30 SEK/stk.", xl: "0,20 SEK/stk." },
          desoRegso: { name: "DeSO/RegSO", small: "0,60 SEK/stk.", medium: "0,50 SEK/stk.", large: "0,40 SEK/stk.", xl: "0,30 SEK/stk." },
        },
      },
    },
    adresstwatt: {
      hero: {
        title: "Adressevask",
        tagline: "Vedligeholdelse af adresseregistre",
        subtitle:
          "Indsend jeres adresseregister – få en vasket, korrigeret og beriget version tilbage. Vi identificerer forkerte adresser, dubletter og forældede oplysninger i Sverige, Norge, Danmark og Finland.",
      },
      overview:
        "Adressevask er Geposits tjeneste til kvalitetssikring af eksisterende adresseregistre i hele Norden. I sender jeres register i et valgfrit format, og vi analyserer hver adresse mod vores opdaterede database for Sverige, Norge, Danmark og Finland. Forkerte adresser korrigeres, dubletter identificeres, og hver adresse beriges med de samme attributter, som Valid leverer – fra region og kommune til koordinater og DeSO/RegSO.",
      featureGroups: {
        analyze: "Analysér & identificér",
        correctAndEnrich: "Korrigér & berig",
      },
      features: {
        title: "Rene adressedata – i hele registeret",
        subtitle:
          "Adressevask tager hånd om jeres eksisterende adressedata og sørger for, at de holder høj kvalitet.",
        items: {
          analyze: {
            title: "Registeranalyse",
            description:
              "Vi analyserer jeres eksisterende register og identificerer forkerte, ufuldstændige og forældede adresser. I får en komplet kvalitetsrapport.",
          },
          correct: {
            title: "Korrektion mod officielle data",
            description:
              "Forkerte adresser korrigeres automatisk mod vores opdaterede database med officielle adresser fra nordiske grundkilder.",
          },
          duplicates: {
            title: "Dubletfjernelse",
            description:
              "Identificér og håndtér dubletter i jeres registre. Sammenflet, markér eller fjern for at få et rent kunderegister.",
          },
          enrich: {
            title: "Berigelse med attributter",
            description:
              "Hver adresse beriges med de samme attributter som Valid: region, kommune, koordinater, ejendomsbetegnelse, DeSO/RegSO med mere.",
          },
          report: {
            title: "Kvalitetsrapport",
            description:
              "Få en detaljeret rapport med statistik over antallet af korrigerede, fjernede og berigede adresser. Se præcis, hvad der er gjort.",
          },
          flexible: {
            title: "Fleksible formater",
            description:
              "Send jeres adresser i CSV, Excel eller via API. Få den vaskede version tilbage i samme format – klar til import.",
          },
        },
      },
      useCases: {
        title: "Anvendelsesområder",
        items: {
          registerCare: {
            title: "Registervedligeholdelse",
            description:
              "Regelmæssig vask af kunderegistre for at holde datakvaliteten høj. Kør kvartalsvis eller før vigtige kampagner.",
          },
          campaigns: {
            title: "Kampagneudsendelser",
            description:
              "Vask registeret før fysiske udsendelser. Undgå omkostningen ved breve, der ikke når frem på grund af forkerte adresser.",
          },
          gdpr: {
            title: "GDPR & datakvalitet",
            description:
              "Identificér og rens forældede adresser som en del af jeres GDPR-arbejde. Behold kun de data, I faktisk har brug for.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Adressevask?",
        items: {
          quality: {
            title: "Højere datakvalitet",
            description:
              "Et rent adresseregister er fundamentet for al logistik, markedsføring og kundekommunikation.",
          },
          savings: {
            title: "Direkte besparelser",
            description:
              "Hver korrigeret adresse reducerer omkostningen ved returneringer, fejludsendelser og manuel håndtering.",
          },
          compliance: {
            title: "Bedre kundedata",
            description:
              "Korrekte adresser forbedrer jeres CRM-data og giver bedre grundlag for forretningsbeslutninger.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Indsend jeres register",
            description:
              "Upload jeres adresseregister i CSV, Excel eller via API. Vi understøtter alle gængse formater.",
          },
          second: {
            title: "Vi analyserer og vasker",
            description:
              "Hver adresse kontrolleres, korrigeres mod officielle data, beriges med attributter, og dubletter fjernes.",
          },
          third: {
            title: "Få rent register tilbage",
            description:
              "I får jeres register tilbage – korrigeret, beriget og med en detaljeret kvalitetsrapport.",
          },
        },
      },
    },
    pricing: {
      tagline: "PAKKER OG PRISER",
      title: "Vælg den pakke, der passer jer",
      subtitle: "Alle pakker inkluderer support og adgang til vores dokumentation. Har I brug for større mængder? Kontakt os for en skræddersyet løsning.",
      recommended: "Anbefalet",
      cta: "Kom i gang",
      ctaHighlighted: "Kom i gang",
      showAddons: "Vis tilvalg og variable priser",
      hideAddons: "Skjul tilvalg",
      addonColumn: "Tilvalg",
      perMonth: "/ md.",
      shortBinding: "3 md. bindingsperiode",
    },
  },
  solutionPages: {
    backToSolutions: "Alle løsninger",
    ctaButton: "Book demo",
    ctaSecondary: "Se vores tjenester",
    readMore: "Læs mere",
    overview: {
      tagline: "LØSNINGER",
      title: "Løsninger til din branche",
      subtitle: "Uanset om du arbejder med transport, service eller e-handel – Geposit giver dig værktøjerne til at optimere din geografi og adressedata.",
      segments: {
        transport: {
          title: "Transport & Logistik",
          description: "Optimér leveringsområder, reducér returneringer og sikr, at hver levering når den rigtige adresse. Definér egne zoner og få fuld kontrol over transportgeografien.",
        },
        service: {
          title: "Service & Installation",
          description: "Planlæg serviceområder uden overlap, fordel ressourcer effektivt og giv jeres kunder præcise besøgstider baseret på geografisk data.",
        },
        ecommerce: {
          title: "E-handel & Omni",
          description: "Validér kundeadresser i realtid, definér leveringszoner og optimér jeres sidste-mil-logistik for tilfredse kunder og færre returneringer.",
        },
      },
      cta: {
        title: "Usikker på, hvilken løsning der passer?",
        subtitle: "Kontakt os, så hjælper vi dig med at finde den rigtige løsning til din virksomhed.",
      },
    },
    transport: {
      hero: {
        tagline: "Transport & Logistik",
        title: "Effektivere leveringer med geografisk kontrol",
        subtitle: "Definér leveringsområder med postnummerpræcision, sikr korrekte adressedata og reducér returneringer – så hver levering når den rigtige modtager til rette tid.",
      },
      challenges: {
        title: "Udfordringer inden for transport",
        subtitle: "Transportvirksomheder kæmper dagligt med geografiske og adresserelaterede problemer, der koster tid og penge.",
        items: {
          zones: {
            title: "Uklare leveringszoner",
            description: "Uden tydeligt definerede leveringsområder havner pakker forkert, zoner overlapper, og chaufføren spilder tid på at afklare grænser.",
          },
          routes: {
            title: "Uklare grænser",
            description: "Uden datadrevet zoneplanlægning baseres ansvarsområder på mavefornemmelse. Det fører til overlappende zoner og huller i dækningen.",
          },
          returns: {
            title: "Høje returomkostninger",
            description: "Forkerte eller ufuldstændige adresser fører til mislykkede leveringer. Hver retur koster penge og forværrer kundeoplevelsen.",
          },
        },
      },
      solutions: {
        title: "Sådan hjælper Geposit transportvirksomheder",
        subtitle: "Med de rigtige værktøjer kan I tage kontrol over jeres leveringsgeografi og reducere kostbare fejl.",
        items: {
          areas: {
            title: "Definér leveringsområder i Atlas",
            description: "Opret og visualisér egne leveringszoner i Atlas med postnummerflader som byggesten. Ingen flere uklare grænser – alle ser det samme billede.",
          },
          data: {
            title: "Validér adresser med Valid",
            description: "Med Valid valideres hver adresse før levering. Forkerte adresser fanges direkte ved indtastning, og I undgår kostbare returneringer.",
          },
          optimize: {
            title: "Hold registeret rent med Adressevask",
            description: "Vask kunderegistrene regelmæssigt med Adressevask. Analysér leveringsområderne og sikr, at zoneinddelingen matcher virkeligheden.",
          },
        },
      },
      products: {
        title: "Tjenester til transport",
        subtitle: "Tre værktøjer, der tilsammen giver fuld kontrol over leveringsgeografi og adressekvalitet.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Opret, visualisér og håndtér leveringszoner med postnummerflader som byggesten. Definér områder pr. chauffør, terminal eller region.",
          },
          valid: {
            name: "Valid",
            description: "Validér leveringsadresser i realtid. Fang forkerte adresser, før pakken forlader terminalen, og undgå kostbare returneringer.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Vask kunderegistrene regelmæssigt for at holde adressedata korrekte og opdaterede. Reducér fejlomkostninger og øg leveringspræcision.",
          },
        },
      },
      cta: {
        title: "Klar til at effektivisere jeres leveringer?",
        subtitle: "Book en demo og se, hvordan Geposit kan hjælpe jeres transportvirksomhed med at reducere returneringer og optimere leveringsområder.",
      },
    },
    service: {
      hero: {
        tagline: "Service & Installation",
        title: "Smartere planlægning af serviceområder",
        subtitle: "Fordel ressourcer geografisk, eliminér overlappende zoner og giv jeres kunder præcise besøgstider – med Atlas, Valid og Adressevask som grundlag.",
      },
      challenges: {
        title: "Udfordringer inden for service",
        subtitle: "Servicevirksomheder og installationsfirmaer møder dagligt geografiske udfordringer, der påvirker effektivitet og kundetilfredshed.",
        items: {
          overlap: {
            title: "Overlappende zoner",
            description: "Uden tydelige grænser mellem serviceområder risikerer I at sende flere teknikere til det samme område, mens andre områder er underbemandede.",
          },
          resources: {
            title: "Ulige ressourcefordeling",
            description: "Nogle teknikere har for store områder, andre for små. Uden geografisk analyse baseres fordelingen på mavefornemmelse.",
          },
          scheduling: {
            title: "Upræcis tidsplanlægning",
            description: "Uden korrekte adresser og afstandsberegninger bliver tidsvinduer upålidelige, hvilket fører til utilfredse kunder.",
          },
        },
      },
      solutions: {
        title: "Sådan hjælper Geposit servicevirksomheder",
        subtitle: "Med Geposits værktøjer kan I planlægge, visualisere og optimere jeres serviceområder baseret på data.",
        items: {
          zones: {
            title: "Tydelige serviceområder i Atlas",
            description: "Definér præcise serviceområder i Atlas med postnummerflader – ingen overlap, ingen huller. Hver tekniker kender sit præcise ansvarsområde.",
          },
          address: {
            title: "Find frem med Valid",
            description: "Med Valid sikres, at hver kundeadresse er korrekt ved booking. Teknikeren finder frem med det samme, og I undgår kostbare forgæves kørsler.",
          },
          balance: {
            title: "Rene data med Adressevask",
            description: "Vask kunderegistrene med Adressevask og analysér serviceområderne med underlagsdata som antal kunder, afstande og rejsetider.",
          },
        },
      },
      products: {
        title: "Tjenester til service",
        subtitle: "Værktøjer, der giver jeres serviceteam de rigtige forudsætninger fra start.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Opret og håndtér serviceområder visuelt med postnumre som grundlag. Fordel teknikere pr. zone og se hele jeres servicegeografi på ét kort.",
          },
          valid: {
            name: "Valid",
            description: "Validér kundeadresser ved booking. Undgå forgæves kørsler ved at sikre, at hver serviceadresse er korrekt.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Rens jeres kunderegister for forkerte adresser. Sørg for, at serviceplatformen bygger på korrekte og opdaterede data.",
          },
        },
      },
      cta: {
        title: "Klar til at optimere jeres serviceområder?",
        subtitle: "Book en demo og se, hvordan Geposit kan hjælpe jeres servicevirksomhed med at planlægge smartere og levere bedre.",
      },
    },
    ecommerce: {
      hero: {
        tagline: "E-handel & Omni",
        title: "Perfekt levering i hver kanal",
        subtitle: "Validér kundeadresser direkte i kassen, definér leveringszoner og sikr, at hver ordre når den rigtige modtager – uanset kanal. Med Valid, Atlas og Adressevask.",
      },
      challenges: {
        title: "Udfordringer inden for e-handel",
        subtitle: "E-handlere og omnikanal-virksomheder kæmper med adressekvalitet og leveringspræcision i et stadig mere krævende marked.",
        items: {
          delivery: {
            title: "Utydelige leveringszoner",
            description: "Uden definerede leveringsområder er det svært at tilbyde differentierede forsendelsesmuligheder og pris pr. zone.",
          },
          returns: {
            title: "Returneringer pga. adressefejl",
            description: "Kunder indtaster forkerte adresser, og uden validering sendes pakken alligevel. Resultatet: returneringer, omkostninger og utilfredse kunder.",
          },
          expansion: {
            title: "Nordisk ekspansion",
            description: "At ekspandere til nye nordiske markeder kræver korrekte adressedata for hvert land. Forkerte data hindrer vækst og øger omkostningerne.",
          },
        },
      },
      solutions: {
        title: "Sådan hjælper Geposit e-handlere",
        subtitle: "Med de rigtige data og værktøjer kan I reducere returneringer, forbedre kundeoplevelsen og ekspandere tryggere.",
        items: {
          zones: {
            title: "Smarte leveringszoner i Atlas",
            description: "Definér leveringsområderne i Atlas med postnummerflader og tilknyt dem til jeres forsendelsesmuligheder. Tilbyd det rigtige leveringsvalg baseret på kundens adresse – automatisk.",
          },
          validation: {
            title: "Adressevalidering med Valid i kassen",
            description: "Med Valid valideres kundens adresse direkte ved indtastning. Autocomplete giver smarte forslag, og forkerte adresser korrigeres, før ordren oprettes.",
          },
          quality: {
            title: "Rene kundedata med Adressevask",
            description: "Vask kunderegistrene regelmæssigt med Adressevask. Hold jeres CRM-data rene og opdaterede for bedre markedsføring og leveringspræcision.",
          },
        },
      },
      products: {
        title: "Tjenester til e-handel",
        subtitle: "Alt I behøver for korrekte adressedata og optimeret leveringslogistik.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Definér leveringszoner pr. region eller forsendelsesmetode med postnummerflader som grundlag. Se leveringsområderne på kortet og optimér forsendelsesstrukturen.",
          },
          valid: {
            name: "Valid",
            description: "Integrér adressevalidering direkte i jeres kasse. Giv kunden de rigtige adresseforslag og undgå leveringsproblemer fra start.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Kvalitetssikr jeres kunderegistre og hold data fejlfrie. Perfekt til regelmæssig rensning før kampagner og udsendelser.",
          },
        },
      },
      cta: {
        title: "Klar til at forbedre jeres leveringspræcision?",
        subtitle: "Book en demo og se, hvordan Geposit kan hjælpe jeres e-handel med at reducere returneringer og validere adresser i realtid.",
      },
    },
  },
  socialProof: {
    logoTitle: "Over 900 virksomheder stoler på Geposit",
    title: "Hvad vores kunder siger",
    subtitle: "Vi hjælper ledende nordiske virksomheder med at tage kontrol over deres geografi.",
    testimonials: {
      first: {
        quote:
          "Nu har vi langt færre områder, hvor vi mangler dækning for vores tjenester. Tidligere havde vi 'blinde pletter' i dele, vi ellers kunne have leveret til. Overblikket i Atlas har gjort vores optageområder både tydeligere og enklere.",
        author: "Björn Nilsson",
        company: "Systemansvarlig Web, Elon",
      },
      second: {
        quote:
          "Smidig tjeneste til at specificere leveringsområder og opdele dem i forskellige zoner. Nemt at eksportere postnummerlister for hvert område.",
        author: "Julian Lee",
        company: "Grundlægger, Airmee",
      },
    },
  },
  customerCases: {
    hero: {
      title: "Kundecases",
      subtitle: "Se, hvordan nordiske virksomheder bruger Geposit til at optimere deres geografi, reducere returneringer og effektivisere deres logistik.",
    },
    logos: {
      title: "Virksomheder, der bruger Geposit",
      subtitle: "Over 900 virksomheder, organisationer og myndigheder stoler på vores data.",
    },
    featured: {
      tagline: "Kundecase",
      title: "Hurtigere leveringer for markedslederen",
      company: "Best Transport",
      companyDesc: "Markedsledende aktør inden for hurtige leveringer i Norden.",
      description: "Best Transport er en markedsledende aktør inden for hurtige leveringer i Norden. For at imødekomme kundernes krav om hurtige og præcise leveringer stilles høje krav til velplanlagte og tydelige geografiske zoner.",
      result: "Med hjælp fra korttjenesten Atlas som et ensartet planlægningsværktøj kunne Best Transport skabe både bedre overblik og optimale distributionszoner. Resultatet blev højere fyldningsgrad i køretøjerne og dermed forbedret rentabilitet, reducerede CO₂-udledninger – og tilfredse kunder!",
      stats: {
        efficiency: {
          value: "Fyldningsgrad",
          label: "Højere fyldningsgrad i køretøjerne",
        },
        emissions: {
          value: "CO₂",
          label: "Reducerede karbondioxid-udledninger",
        },
        satisfaction: {
          value: "Tilfredshed",
          label: "Tilfredse slutkunder",
        },
      },
      bullets: {
        challenge: "Kompleks zonestruktur med mange overlappende tjenester",
        solution: "Atlas som ensartet planlægningsværktøj til zoneinddeling",
        outcome: "Optimale distributionszoner med højere fyldningsgrad",
      },
    },
    testimonials: {
      title: "Hvad vores kunder siger",
      elon: {
        quote: "Nu har vi langt færre områder, hvor vi mangler dækning for vores tjenester. Tidligere havde vi 'blinde pletter' i dele, vi ellers kunne have leveret til. Overblikket i Atlas har gjort vores optageområder både tydeligere og enklere.",
        author: "Björn Nilsson",
        role: "Systemansvarlig Web",
        company: "Elon",
      },
      airmee: {
        quote: "Smidig tjeneste til at specificere leveringsområder og opdele dem i forskellige zoner. Nemt at eksportere postnummerlister for hvert område.",
        author: "Julian Lee",
        role: "Grundlægger",
        company: "Airmee",
      },
    },
    cta: {
      title: "Vil du være den næste succeshistorie?",
      subtitle: "Book en demo og se, hvordan Geposit kan effektivisere netop jeres virksomhed.",
      button: "Book demo",
    },
  },
  cta: {
    title: "Klar til at tage kontrol?",
    subtitle:
      "Tal med os om, hvordan Geposit kan hjælpe jeres virksomhed med at optimere geografi og adressekvalitet.",
    form: {
      company: "Virksomhedsnavn",
      name: "Navn",
      email: "E-mail",
      role: "Rolle",
      interest: "Hvad vil du vide mere om?",
      interestOptions: {
        atlas: "Atlas – Geografiske områder",
        valid: "Valid – Adressevalidering",
        adresstwatt: "Adressevask – Adresserensning",
        general: "Generel information",
      },
      message: "Besked (valgfrit)",
      submit: "Send forespørgsel",
      success: "Tak for din forespørgsel! Vi vender tilbage til dig hurtigst muligt.",
    },
  },
  footer: {
    description:
      "Geposit er Nordens førende platform for adresse- og geodata. Med korrekte og opdaterede grunddata tilbyder vi webbaserede tjenester, integrationer via API og data på fil.",
    quickLinks: "Hurtiglinks",
    products: "Tjenester",
    contact: "Kontakt",
    address: "Biblioteksgatan 29, 114 35 Stockholm",
    email: "info@geposit.se",
    phone: "+46 8 410 239 70",
    partOf: "En del af Movement Software",
    progritsDesc:
      "Siden 2015 er Geposit en del af Movement Software (tidligere Progrits) – en international softwarekoncern med fokus på e-handel, logistik og køretøjer.",
    sister: "Søsterselskab",
    postnummerservice: "Postnummerservice",
    postnummerserviceDesc:
      "Postnummerservice har siden 2005 hjulpet privatpersoner, virksomheder og organisationer i Norden med korrekte og opdaterede adresse-, postnummer- og geodata.",
    copyright: "© 2026 Geposit AB. Alle rettigheder forbeholdes.",
    privacy: "Privatlivspolitik",
    terms: "Vilkår",
  },
  about: {
    hero: {
      title: "Om Geposit",
      subtitle: "Fra svensk forhandler til nordisk SaaS-virksomhed inden for geodata",
    },
    story: {
      title: "Vores historie",
      p1: "Geposit er en nordisk leverandør af digitale tjenester inden for adresse- og geodata. Vores rejse begyndte i 2005 under navnet Postnummerservice, da vi leverede opdaterede adresse- og postnummerdata til vores kunder.",
      p2: "I 2010 lancerede vi automatisk adressekontrol, og året efter kom vores første digitale korttjeneste til zoneinddeling. I dag tilbyder vi digitale tjenester, der forenkler, kvalitetssikrer og automatiserer håndteringen af adresser og geografiske data.",
      p3: "I dag bruges vores tjenester af virksomheder i hele Norden. Uanset om du har brug for adresse- og datarensning, smart zoneinddeling eller geodatatjenester via API, bygger vores løsninger altid på korrekte og opdaterede grunddata.",
    },
    data: {
      title: "Nordens mest pålidelige adressedata",
      description: "Vidste du, at adresser og postnumre ændrer sig hver uge? Nye boligområder vokser frem, veje ombygges, og byer forandrer sig. Hvert år opdateres ca. 250.000 adresser og postnumre i Sverige, hvilket påvirker op mod en halv million mennesker.",
      description2: "Hos Geposit indsamler vi løbende data fra pålidelige og officielle grundkilder som nationale postoperatører, matrikelmyndigheder og offentlige myndigheder. Takket være den høje kvalitet i vores dataleverancer er vi i dag en værdsat partner for over 900 virksomheder, organisationer og myndigheder.",
      stats: {
        customers: "+5.000",
        customersLabel: "Tilfredse kunder siden 2005",
        countries: "4",
        countriesLabel: "Nordiske lande",
        addresses: "250.000",
        addressesLabel: "Adresseændringer pr. år i Sverige",
      },
    },
    values: {
      title: "Vi drives af",
      innovation: {
        title: "Teknisk innovation",
        description: "Vi udvikler konstant nye løsninger med kundens nytte i centrum. Vores teknologi bygger på pålidelige og opdaterede grunddata.",
      },
      trust: {
        title: "Tillid og samarbejde",
        description: "Vi tror på, at tillid, inklusion og et opmuntrende klima fører til engagement og fælles succes.",
      },
      quality: {
        title: "Kvalitet i hver detalje",
        description: "Vores data opdateres hver uge fra officielle grundkilder. Vi går aldrig på kompromis med kvaliteten.",
      },
    },
    progrits: {
      title: "En del af Movement Software",
      description: "Siden 2015 er Geposit en del af Movement Software (tidligere Progrits) – en international virksomhedsgruppe inden for nichesoftware og informationstjenester til business to business.",
      description2: "Inden for Movement Software samarbejder vi med andre B2B-virksomheder om at skabe stærkere kundetilbud og bedre arbejdsmetoder.",
      tagline: "WE MOVE YOUR WORLD",
      link: "Besøg movementsoftware.com",
    },
    postnummerservice: {
      title: "Søsterselskab: Postnummerservice",
      description: "Postnummerservice har siden 2005 hjulpet privatpersoner, virksomheder og organisationer i Norden ved at levere korrekte og opdaterede adresse-, postnummer- og geodata.",
      description2: "Postnummerservice indsamler og bearbejder data fra pålidelige grundkilder som nationale postoperatører, matrikelmyndigheder og officielle myndigheder. Data opdateres hver uge for at garantere høj kvalitet og præcision.",
      link: "Besøg postnummerservice.se",
    },
    ecoroute: {
      title: "Søsterselskab: Ecoroute",
      description: "Ecoroute udvikler smart ruteplanlægning og optimering til transport- og logistikvirksomheder i Norden. Med fokus på effektivitet og bæredygtighed hjælper de deres kunder med at reducere kørte kilometer, sænke omkostninger og mindske klimaaftrykket.",
      description2: "Inden for Movement Softwares fokusområde Transportation & Logistics kombinerer vi Ecoroutes ruteoptimering med Geposits adresse- og geodatatjenester for helhedsløsninger gennem hele leveringskæden.",
      link: "Besøg ecoroute.com",
    },
    careers: {
      title: "Bliv en del af Geposit",
      description: "Vi vokser og leder altid efter nye talenter. Vi drives af teknisk innovation med kravet om, at værdien for vores kunder altid står i centrum.",
      cta: "Kontakt os",
    },
  },
  information: {
    title: "Information",
    subtitle: "Nyheder, dokumenter og vigtig information fra Geposit.",
    news: {
      title: "Nyheder",
      subtitle: "Seneste nyt fra Geposit – opdateringer, forbedringer og nyheder.",
      empty: "Ingen nyheder publiceret endnu.",
    },
    documents: {
      title: "Dokumenter og vilkår",
      subtitle: "Her finder du vores generelle vilkår, politikker og andre dokumenter.",
    },
    quickNav: {
      news: "Nyheder",
      documents: "Dokumenter & vilkår",
    },
    readMore: "Læs mere",
    categories: {
      villkor: "Vilkår",
      policy: "Politik",
      ovrigt: "Andet",
    },
  },
  cookieBanner: {
    title: "Vi bruger cookies",
    description: "Vi bruger cookies til at forbedre din oplevelse på vores hjemmeside, analysere trafik og tilpasse indhold.",
    readMore: "Læs vores cookiepolitik",
    accept: "Accepter",
    reject: "Afvis",
  },
  cookiePolicy: {
    title: "Cookiepolitik",
    lastUpdated: "Sidst opdateret: 2024-03-18",
    intro: "Vi indsamler oplysninger ved hjælp af teknologi som cookies (f.eks. i din browser eller enhed). Cookies bruges til at gemme og modtage id'er og andre oplysninger på computere, telefoner og andre enheder. Cookies kan for eksempel hjælpe os med at genkende dig næste gang du besøger vores hjemmeside, men også gøre det muligt for os at tilbyde en mere sikker og driftssikker tjeneste.",
    purposeTitle: "Vi bruger cookies til følgende formål",
    types: {
      functional: {
        title: "Funktionelle cookies",
        description: "Vi bruger funktionelle cookies til at håndtere visse funktioner på vores sider, så dine valg og indstillinger huskes, når du vender tilbage til hjemmesiden.",
      },
      analytics: {
        title: "Analysecookies",
        description: "Vi bruger analysecookies til at måle, hvordan vores tjenester efterspørges, bruges og fungerer. De oplysninger, vi indsamler, bruges til at vedligeholde og forbedre vores tjeneste.",
      },
      thirdParty: {
        title: "Tredjepartscookies",
        description: "Vi kan også tillade vores samarbejdspartnere at bruge cookies i vores tjenester til de samme formål som beskrevet ovenfor. Vi kan også lade tredjeparter, der tilbyder tjenester på vores vegne, bruge cookies til de formål, der er beskrevet ovenfor.",
      },
    },
    managingTitle: "Håndtering af cookies",
    managingText: "De fleste browsere lader brugeren vælge, hvordan cookies skal håndteres. Du kan indstille browseren til at nægte cookies eller til at slette visse cookies. Her finder du information om, hvordan du håndterer cookies i din browser:",
    blockingWarning: "Hvis du vælger at blokere cookies, kan dele af vores tjenestes funktionalitet forringes eller forsvinde, da den forudsætter, at cookies tillades.",
    changesTitle: "Ændringer i denne politik",
    changesText: "Geposit kan fra tid til anden ændre denne cookiepolitik ved ændrede rutiner for brug af cookies og behandling af data samt for at overholde lovkrav.",
    contactTitle: "Spørgsmål",
    contactText: "Hvis du har spørgsmål eller bekymringer om vores brug af cookies, er du velkommen til at kontakte os.",
  },
  notFound: {
    title: "404",
    message: "Siden blev ikke fundet",
    backHome: "Tilbage til forsiden",
  },
  kontakt: {
    title: "Kontakt",
    hero: {
      title: "Hvordan kan vi hjælpe dig?",
      subtitle: "Book en gratis demo eller kontakt os med dine spørgsmål – vi hjælper dig med at finde den rette løsning.",
    },
    types: {
      demo: {
        title: "Book demo",
        description: "Få en gratis gennemgang af vores tjenester, tilpasset jeres virksomhed.",
      },
      contact: {
        title: "Kontakt os",
        description: "Har du spørgsmål om vores produkter, priser eller samarbejde? Kontakt os!",
      },
    },
    contactInfo: {
      title: "Kontaktoplysninger",
    },
    form: {
      titleDemo: "Book en gratis demo",
      subtitleDemo: "Udfyld formularen, så kontakter vi dig for at aftale et tidspunkt, der passer.",
      titleContact: "Send en besked",
      subtitleContact: "Beskriv dit ærinde, og vi vender tilbage hurtigst muligt.",
      submitDemo: "Book demo",
      submitting: "Sender...",
      success: "Tak! Vi har modtaget din besked og vender tilbage til dig snarest.",
      error: "Noget gik galt. Prøv igen eller kontakt os via e-mail.",
      placeholders: {
        company: "Virksomhed A/S",
        name: "Anders Andersen",
        email: "anders@virksomhed.dk",
        role: "Logistikchef",
        interest: "Vælg et alternativ",
        messageDemo: "Fortæl gerne kort om jeres virksomhed og hvad I gerne vil se i demoen...",
        messageContact: "Fortæl gerne mere om dit ærinde...",
      },
    },
  },
  illustrations: {
    keyFactors: "Nøglefaktorer",
    joinCompanies: "Tilslut jer 900+ virksomheder, der allerede bruger Geposit",
    zoneA: "Zone A",
    zoneB: "Zone B",
    zoneC: "Zone C",
    searchAddress: "Søg adresse…",
    processing: "Behandler…",
    completed: "færdige",
    analysisResult: "Analyseresultat",
    addresses: "adresser",
    correctedAddresses: "Korrigerede adresser",
    addressFile: "adressevask.csv",
  },
  seo: {
    home: "Geposit hjælper virksomheder med at oprette, administrere og optimere deres geografiske områder med korrekte adressedata i Sverige, Norge, Danmark og Finland.",
    losningar: "Løsninger til transport, service og e-handel. Optimer leveringsområder og geografisk planlægning i hele Norden med Geposit.",
    produkter: "Opdag Atlas, Valid og Adressevask – værktøjer til geografisk områdestyring og adressekvalitet i Sverige, Norge, Danmark og Finland.",
    kundcase: "Se hvordan 900+ virksomheder bruger Geposit til geografisk kontrol, bedre adressekvalitet og optimerede leveringszoner i Norden.",
    information: "Nyheder, opdateringer og dokumenter fra Geposit om geografiske data, adressekvalitet og områdestyring i Norden.",
    omGeposit: "Geposit hjælper nordiske virksomheder med geografisk kontrol og adressekvalitet. En del af Movement Software-koncernen.",
    kontakt: "Kontakt Geposit – book en gratis demo eller stil spørgsmål om vores produkter og tjenester til geografiske data.",
    integritetspolicy: "Geposits privatlivspolitik – sådan håndterer vi dine personoplysninger og cookies.",
  },
  order: {
    pageTitle: "Bestil",
    pageDescription: "Bestil Atlas eller Valid fra Geposit.",
    selectProduct: "Vælg produkt",
    selectProductDesc: "Hvilket produkt vil du bestille?",
    chooseThis: "Vælg dette",
    configureAtlas: "Konfigurer Atlas",
    configureAtlasDesc: "Vælg pakke og konfigurer dit abonnement.",
    configureValid: "Konfigurer Valid",
    configureValidDesc: "Vælg pakke og eventuelle tilvalg.",
    choosePlan: "Vælg pakke",
    perMonth: "/md",
    binding12: "12 md. bindingsperiode",
    binding3: "3 md. bindingsperiode",
    perMonthShort: "md",
    adminUsers: "Admin-brugere",
    adminUsersDesc: "1 inkluderet. Ekstra: 295 SEK/md",
    viewerUsers: "Se-brugere",
    viewerUsersDesc: "0 inkluderet. Ekstra: 95 SEK/md",
    maps: "Kort",
    mapsDesc: "1 inkluderet. Ekstra: 495 SEK/md",
    countries: { title: "Lande", desc: "Mindst 1 land kræves. Første inkluderet, ekstra: 1.000 SEK/md", se: "Sverige", no: "Norge", dk: "Danmark", fi: "Finland" },
    addons: "Tilvalg",
    addonsDesc: "Vælg hvilke tilvalg du ønsker udover grundpakken.",
    userDetails: "Brugeroplysninger",
    userDetailsDesc: "Angiv navn, e-mail og rolle for hver bruger.",
    adminUser: "Admin-bruger",
    viewerUser: "Se-bruger",
    userName: "Navn",
    userNamePlaceholder: "Fornavn Efternavn",
    userEmail: "E-mailadresse",
    userEmailPlaceholder: "navn@virksomhed.dk",
    userRole: "Rolle",
    userRolePlaceholder: "f.eks. Områdeansvarlig",
    noUsersNeeded: "Ingen brugeroplysninger nødvendige for dette produkt.",
    customerDetails: "Kunde- & fakturaoplysninger",
    customerDetailsDesc: "Udfyld kontakt-, virksomheds- og fakturaoplysninger.",
    contactInfo: "Kontaktoplysninger",
    firstName: "Fornavn",
    lastName: "Efternavn",
    phone: "Telefon",
    email: "E-mailadresse",
    companyInfo: "Virksomhedsoplysninger",
    companyName: "Virksomhedsnavn",
    orgNumber: "CVR-nummer",
    orgNumberHint: "10 cifre, udfyld med nuller om nødvendigt",
    address: "Adresse",
    postalCode: "Postnummer",
    city: "By",
    country: "Land",
    billingInfo: "Fakturaoplysninger",
    copyFromCompany: "Kopiér fra virksomhedsoplysninger",
    billingAddress: "Faktureringsadresse",
    reference: "Jeres reference",
    referenceHint: "F.eks. navn på kontaktperson",
    poNumber: "Reference/PO-nummer",
    poNumberHint: "F.eks. internt indkøbsnummer. Ønsker I at ændre PO-nummer fremover, skal I give os besked.",
    invoiceMethod: "Fakturametode",
    invoiceMethods: { email: "E-mail", einvoice: "E-faktura", letter: "Brev" },
    invoiceEmail: "E-mail til faktura",
    peppolId: "PEPPOL-ID",
    peppolIdHint: "Hvis intet PEPPOL-ID, vælg et andet alternativ",
    letterNotice: "Fakturaen sendes til den angivne faktureringsadresse. Fakturagebyr tillægges.",
    vatNumber: "VAT-nummer",
    termsPrefix: "Jeg accepterer",
    termsLink: "handelsbetingelserne",
    summary: "Oversigt",
    basePlan: "(grundpakke)",
    total: "I alt",
    validAddonsNote: "Tilvalgspriser er pr. stk. og tillægges grundpakken.",
    step: "Trin",
    back: "Tilbage",
    next: "Næste",
    submitOrder: "Gennemfør bestilling",
    submitting: "Sender...",
    confirmationTitle: "Tak for din bestilling!",
    confirmationDesc: "Vi har modtaget din bestilling og vender tilbage med en bekræftelse via e-mail.",
    backToHome: "Tilbage til forsiden",
    errorTitle: "Noget gik galt",
    errorDesc: "Din bestilling kunne ikke sendes. Prøv igen eller kontakt os.",
    share: "Del",
    shareOrder: "Del bestilling",
    shareCopied: "Link kopieret!",
    shareCopiedDesc: "Konfigurationslinket er kopieret til udklipsholderen.",
    shareFullCopied: "Bestillingslink kopieret!",
    shareFullCopiedDesc: "Linket indeholder alle oplysninger. Kunden skal blot acceptere vilkårene.",
    sharedBanner: "Denne bestilling er forberedt til dig. Gennemgå valgene og gå videre for at fuldføre.",
    sharedFullBanner: "Bestillingen er udfyldt for dig. Gennemgå oplysningerne, acceptér vilkårene og send.",
  },
  villkor: {
    hero: {
      tagline: "Dokumenter og vilkår",
      title: "Tydelige vilkår for et trygt samarbejde",
      subtitle: "Her finder du en oversigt over de vigtigste punkter i vores vilkår samt mulighed for at downloade de fuldstændige dokumenter.",
    },
    summary: {
      title: "Oversigt over vores vilkår",
      subtitle: "Nedenfor opsummeres de vigtigste punkter. De fuldstændige vilkår kan downloades længere nede på siden.",
      disclaimer: "Ovenstående er en forenklet opsummering og erstatter ikke de fuldstændige vilkår. Ved eventuelle uoverensstemmelser gælder altid den underskrevne aftale.",
      items: {
        contract: { title: "Aftaleperiode og opsigelse", description: "Aftalen løber i henhold til valgt bindingsperiode og fornys automatisk, medmindre den opsiges skriftligt senest 3 måneder før periodens udløb." },
        payment: { title: "Betaling og priser", description: "Fakturering sker forud. Priser justeres årligt og kommunikeres på forhånd via hjemmesiden." },
        data: { title: "Data og fortrolighed", description: "Geposit behandler kundedata fortroligt og i overensstemmelse med GDPR. Kundedata deles aldrig med tredjepart uden samtykke." },
        responsibility: { title: "Ansvar og garantier", description: "Geposit er ansvarlig for, at tjenesten fungerer i henhold til specifikationen, med visse ansvarsbegrænsninger. Se de fuldstændige vilkår for mere information." },
        availability: { title: "Tilgængelighed og SLA", description: "Tjenesten leveres med høj tilgængelighed. Planlagt nedetid varsles på forhånd, og vedligeholdelsesvinduer foregår uden for kontortid." },
        usage: { title: "Brug og begrænsninger", description: "Tjenesten må anvendes inden for rammerne af aftalen. Misbrug, automatiseret dataudvinding eller videresalg/videredeling uden aftale er ikke tilladt." },
      },
    },
    download: {
      title: "Download de fuldstændige vilkår",
      subtitle: "Her kan du downloade vores fuldstændige aftaledokumenter i PDF-format.",
      open: "Åbn",
      empty: "Ingen dokumenter tilgængelige lige nu.",
    },
    cta: {
      title: "Spørgsmål til vores vilkår?",
      subtitle: "Kontakt os, så hjælper vi dig med at forstå, hvordan vilkårene gælder for netop din virksomhed.",
      button: "Kontakt os",
    },
  },
  certifications: {
    title: "Certificeringer",
    subtitle: "Vi arbejder systematisk med kvalitet, miljø og informationssikkerhed.",
    iso9001: { title: "ISO 9001", description: "Kvalitetsledelse" },
    iso14001: { title: "ISO 14001", description: "Miljøledelse" },
    iso27001: { title: "ISO 27001", description: "Informationssikkerhed" },
  },
  solutionExtras: {
    transport: {
      heroHighlights: [
        "Definér og visualisér leveringszoner med postnummerpræcision i Atlas",
        "Validér alle adresser inden afsendelse med Valid",
        "Hold kunderegisteret rent med Adressevask",
      ],
      challengeImpact: "Forkerte adresser og uklare leveringszoner koster transportvirksomheder millioner årligt i returneringer, forgæves ture og forsinkelser.",
      productBullets: {
        atlas: ["Byg leveringszoner med postnummerpolygoner som byggesten", "Visualisér og analysér områder pr. terminal, chauffør eller region"],
        valid: ["Validér leveringsadresser i realtid, før pakken forlader terminalen", "Fang forkerte og ufuldstændige adresser direkte ved indtastning"],
        adresstwatt: ["Vask kunderegistre regelmæssigt for korrekte adressedata", "Identificér og ret forældede adresser automatisk"],
      },
    },
    service: {
      heroHighlights: [
        "Definér præcise serviceområder med postnummerpræcision i Atlas",
        "Sikr korrekte kundeadresser ved booking med Valid",
        "Hold serviceplatformen ren med Adressevask",
      ],
      challengeImpact: "Overlappende serviceområder og forkerte adresser koster servicevirksomheder i gennemsnit 15–20 % af deres operationelle kapacitet i forgæves ture og dobbeltarbejde.",
      productBullets: {
        atlas: ["Byg serviceområder med postnummerpolygoner – ingen overlap", "Analysér arbejdsbelastning baseret på kundeantal og geografi"],
        valid: ["Validér serviceadresser direkte ved booking for at undgå forgæves ture", "Giv kunder korrekte adresseforslag i realtid via autocomplete"],
        adresstwatt: ["Rens forkerte adresser i kunderegisteret regelmæssigt", "Sørg for, at serviceplatformen bygger på korrekte data"],
      },
    },
    ecommerce: {
      heroHighlights: [
        "Validér kundeadresser direkte i kassen med Valid",
        "Definér leveringszoner med postnummerpræcision i Atlas",
        "Ekspandér trygt til nordiske markeder med korrekte data",
      ],
      challengeImpact: "Forkerte adresser i e-handel betyder, at op til 5 % af alle leveringer mislykkes – og returneringer koster 3–5 gange mere end den oprindelige fragt.",
      productBullets: {
        atlas: ["Byg leveringszoner med postnummerpolygoner pr. region, fragtmetode eller priszone", "Visualisér leveringsområder og eksportér postnummerlister"],
        valid: ["Integrér autocomplete direkte i din kasse for fejlfri adresseindtastning", "Validér adresser i realtid for Sverige, Norge, Danmark og Finland"],
        adresstwatt: ["Kvalitetssikr kunderegistre forud for kampagner og udsendelser", "Identificér dubletter og forældede adresser i bulk"],
      },
    },
  },
  pricingDb: {
    nordicValidation: "Adressevalidering i hele Norden",
    autocomplete: "Autocomplete for gadenavne, postnumre og bynavne",
    adminControl: "Kontrol af region, kommune, sogn og distrikt",
    bindingTime12: "12 måneders bindingsperiode",
    oneAdminMapCountry: "1 admin, 1 kort, 1 land",
    importOwnData: "Importér egne data på kortet",
    createManageAreas: "Opret, vis og administrér områder",
    integrateApi: "Integrér med dine systemer via API",
    export2000Postal: "Eksportér 2.000 postnumre/md",
    exportUnlimitedPostal: "Eksportér ubegrænset med postnumre",
    routingSmallIncluded: "Routing Small inkluderet",
    validationsPerMonth: "Valideringer/md",
    autocompletePerMonth: "Autocomplete/md",
    extraValidation: "Overskydende validering",
    extraAutocomplete: "Overskydende autocomplete",
    geocodeAddress: "Geokodning adresse",
    geocodePostal: "Geokodning postnummer",
    propertyDesignation: "Ejendomsbetegnelse",
    uuid: "UUID",
    desoRegso: "DeSO/RegSO",
    extraCountry: "Ekstra land",
    extraMap: "Ekstra kort",
    extraAdmin: "Ekstra admin",
    extraViewer: "Ekstra kig-bruger",
    exportPostal: "Eksport postnummer",
    exportCoordinates: "Eksport koordinater",
    perQuote: "Efter tilbud",
    included: "Inkluderet",
  },
};

